import { forwardRef } from 'react';
import { NavLink } from 'react-router';
import type { NavLinkProps } from 'react-router';

type MyNavLinkProps = Omit<NavLinkProps, 'style' | 'className'> & {
    activeClassName?: string;
    className?: string;
};
export const MyNavLink = forwardRef<HTMLAnchorElement, MyNavLinkProps>(
    (props, ref) => {
        const {
            className,
            activeClassName = 'active',
            ...navLinkProps
        } = props;
        return (
            <NavLink
                ref={ref}
                {...navLinkProps}
                className={({ isActive }) =>
                    [className, isActive ? activeClassName : '']
                        .filter(Boolean)
                        .join(' ')
                }
            />
        );
    },
);
